export const ExpectedSavingsMenuItems = [
  {
    label: 'Manage savings goals',
    key: 'edit'
  }
]
